/**
 * /devhub/models — Models (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubModelRegistryPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubModelRegistryPanel } from '../features/control-plane/DevHubModelRegistryPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/models')({ component: ModelsPage });

function ModelsPage() {
  return (
    <DevHubPanelPage
      title="Models"
      subtitle="Local Granite + embedding model registry. Owner inference is local and unpaid."
      status={{ label: 'live', live: true }}
    >
      <DevHubModelRegistryPanel />
    </DevHubPanelPage>
  );
}
